import ReactECharts from 'echarts-for-react';

const EChart = (props) => {
    const options = props.option ? props.option : {
        title: {
            text: 'ECharts Example in React'
        },
        tooltip: {},
        legend: {
            data: ['Sales']
        },
        xAxis: {
            data: ['Shirts', 'Cardigans', 'Chiffons', 'Pants', 'Heels', 'Socks']
        },
        yAxis: {},
        series: [
            {
                name: 'Sales',
                type: 'bar',
                data: [5, 20, 36, 10, 10, 20]
            }
        ]
    };

    return (
        <>
            <ReactECharts option={options} style={{ width: '100%',height:"100%"}} />
        </>
    )
}
export default EChart;